import React from "react";
import { toast, Flip } from "react-toastify";
import VideoInfo from "../../components/VideoInfo";
import { connect } from "react-redux";
import { CircularProgress, TextField } from "@material-ui/core";
import CanvasPlayer from "../../components/CanvasPlayer/EditingCanvas";
import VideoEditor from "./Editor";
import { withRouter } from "../../utils/withRouter";
import ChipInput from "material-ui-chip-input";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

import Templates from "../Templates/TemplateIs";
import { Storage } from "aws-amplify";
import { localStorageGet } from "../../util/localStorage";
import {
  updateVideo,
  sendVideoToEmail,
  sendMultipleEmails,
} from "../../Redux/Actions/videos";
import { reg } from "../../constants/emailRegEx";
import _ from "lodash";
import "./style.css";

const { availableTheme } = require("../../constants/constants");
const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === "true";
const storageGet = (key: string, opts: any): Promise<any> =>
  isLocalAuth ? localStorageGet(key, opts) : Storage.get(key, opts);

/* ────────── Template Selection Dialog ────────── */
function TemplateDialog({ open, onClose, selectedValue }: any) {
  return (
    <Dialog onClose={() => onClose(selectedValue)} open={open} maxWidth="sm" fullWidth>
      <div className="vtTemplateDialog">
        <h3 className="vtTemplateDialogTitle">Select Email Template</h3>
        <div className="vtTemplateGrid">
          {availableTheme.map((theme: any) => (
            <button
              key={theme.name}
              className="vtTemplateCard"
              onClick={() => onClose(theme)}
            >
              <img className="vtTemplateAvatar" src={theme.avatar} alt={theme.name} />
              <span className="vtTemplateName">{theme.name}</span>
            </button>
          ))}
        </div>
      </div>
    </Dialog>
  );
}

/* ────────── Share Dialog ────────── */
function ShareDialog({ open, onClose, receiverEmail, emailHandler, submitEmail, handleChipAdd, handleDeleteChip, sendMultipleEmail, emails }: any) {
  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <div className="vtShareDialog">
        <h3 className="vtShareDialogTitle">Share Video</h3>

        <div className="vtShareSection">
          <label className="vtShareLabel">Send to Email</label>
          <div className="vtShareRow">
            <input
              type="email"
              className="vtShareInput"
              placeholder="Enter email address"
              value={receiverEmail}
              onChange={emailHandler}
            />
            <button className="vtShareSendBtn" onClick={submitEmail}>Send</button>
          </div>
        </div>

        <div className="vtShareDivider" />

        <div className="vtShareSection">
          <label className="vtShareLabel">Broadcast to Multiple</label>
          <ChipInput
            value={emails}
            placeholder="Type email and press enter"
            fullWidth
            onAdd={(chips: any) => handleChipAdd(chips)}
            onDelete={(chip: any) => handleDeleteChip(chip)}
            className="vtShareChipInput"
          />
          <button className="vtShareBroadcastBtn" onClick={sendMultipleEmail}>
            Broadcast
          </button>
        </div>
      </div>
    </Dialog>
  );
}

/* ────────── Main Header Component ────────── */
interface Video {
  url: string;
  thumbnail?: string;
  title?: string;
  logoProps?: any;
  textProps?: any;
  musicProps: any;
  _id: string;
  views?: number;
  watch?: number;
  emailShareCount?: number;
  recordingEdit?: boolean;
}
interface IProps {
  video?: Video;
  updateVideo: (video: any) => void;
  sendVideoToEmail: (email: any) => void;
  sendMultipleEmail: (emails: any) => void;
  onTemplateChange?: (theme: any) => void;
  match: any;
}

class VideoTabHeader extends React.Component<IProps> {
  container: any;
  state = {
    height: "auto",
    editLogo: false,
    editMusic: false,
    editText: false,
    editThumbnail: false,
    editTitle: false,
    title: "",
    themeName: "",
    selectedTheme: "",
    open: false,
    forShare: false,
    receiverEmail: "",
    emails: [],
    url: "",
    thumbnail: "",
  };

  componentDidMount() {
    if (this.props.video !== null) {
      // @ts-ignore
      storageGet(this.props.video.url, { level: "protected" }).then((response: any) => {
        this.setState({ url: response });
      });
      // @ts-ignore
      if (!_.isNil(this.props.video.thumbnail) && !_.isEmpty(this.props.video.thumbnail)) {
        // @ts-ignore
        storageGet(this.props.video.thumbnail, { level: "protected" }).then((response: any) => {
          this.setState({ thumbnail: response });
        });
      }
    }
  }

  copyUrl = () => {
    const { video } = this.props;
    const newClip = `${process.env.REACT_APP_DOMAIN}/watch/${video && video._id}`;
    navigator.clipboard.writeText(newClip);
    toast("URL copied to clipboard", { autoClose: 1200, transition: Flip, hideProgressBar: true });
  };

  handleEditTitle = () => this.setState({ editTitle: true });

  saveVideo = () => {
    const { video } = this.props;
    const { title } = this.state;
    this.props.updateVideo({ id: video?._id, title });
    this.setState({ editTitle: false });
  };

  handleInputChange = (input: any) => this.setState({ title: input.value });

  handleCloseTemplate = (theme: any) => {
    this.setState({ selectedTheme: theme });
    if (!theme.name) return this.setState({ open: false });
    const { video } = this.props;
    this.props.updateVideo({ id: video?._id, eMailTemplate: theme.name });
    if (this.props.onTemplateChange) this.props.onTemplateChange(theme);
    this.setState({ open: false });
  };

  emailHandler = (event: any) => this.setState({ receiverEmail: event.target.value });

  handleChipAdd = (email: any) => {
    if (!reg.test(email)) { toast.error("Not a valid email"); return; }
    this.setState({ emails: [...this.state.emails, email] });
  };
  handleDeleteChip = (delEmail: any) => {
    this.setState({ emails: this.state.emails.filter((e: string) => e !== delEmail) });
  };

  submitEmail = () => {
    const { id } = this.props.match.params;
    if (!id) return toast.warn("No video to share");
    if (!this.state.receiverEmail) return toast.warn("Add an email");
    if (!reg.test(this.state.receiverEmail)) return toast.warn("Invalid email");
    this.props.sendVideoToEmail({ videoId: id, recieverEmail: this.state.receiverEmail });
    this.setState({ forShare: false });
  };

  sendMultipleEmail = () => {
    const { id } = this.props.match.params;
    if (this.state.emails.length === 0) { toast.error("No email provided"); return; }
    if (!id) { toast.error("No video saved"); return; }
    if (this.state.emails.length < 2) { toast.error("Add at least two emails"); return; }
    const emails = this.state.emails.join();
    this.props.sendMultipleEmail({ recieverEmail: emails, videoId: id });
    this.setState({ emails: [] });
  };

  render() {
    const { video } = this.props;
    const { editTitle, themeName, open, forShare, receiverEmail, emails } = this.state;

    return (
      <div className="vtHeader">
        {/* Video Player */}
        <div className="vtPlayerWrap">
          {!video ? (
            <div className="vtPlayerLoading"><CircularProgress size={32} /></div>
          ) : (
            <CanvasPlayer
              muted={false}
              autoPlay={true}
              loop={true}
              src={video.url}
              logoProps={video.logoProps}
              textProps={video.textProps}
              thumbnail={video.thumbnail}
              musicProps={video.musicProps}
            />
          )}
        </div>

        {/* Title */}
        <div className="vtTitleRow">
          {editTitle ? (
            <div className="vtTitleEditRow">
              <input
                className="vtTitleInput"
                defaultValue={video && video.title}
                onChange={(e: any) => this.handleInputChange(e.currentTarget)}
                autoFocus
              />
              <button className="vtTitleSaveBtn" onClick={this.saveVideo}>Save</button>
              <button className="vtTitleCancelBtn" onClick={() => this.setState({ editTitle: false })}>Cancel</button>
            </div>
          ) : (
            <div className="vtTitleDisplay">
              <h2 className="vtVideoTitle">{video && video.title}</h2>
              <button className="vtTitleEditBtn" onClick={this.handleEditTitle}>Edit</button>
            </div>
          )}
        </div>

        {/* Stats */}
        <div className="vtStats">
          <VideoInfo video={video} />
        </div>

        {/* Editing Tools */}
        <div className="vtToolsSection">
          <h4 className="vtToolsSectionTitle">Editing Tools</h4>
          <div className="vtToolsGrid">
            {([
              { label: "Captions", icon: "Aa", key: "editText" },
              { label: "Logo", icon: "Lg", key: "editLogo" },
              { label: "Music", icon: "Mu", key: "editMusic" },
              { label: "Thumbnail", icon: "Th", key: "editThumbnail" },
            ] as const).map((tool) => (
              <button
                key={tool.key}
                className="vtToolBtn"
                onClick={() => this.setState({ [tool.key]: true } as any)}
              >
                <span className="vtToolIcon">{tool.icon}</span>
                <span className="vtToolLabel">{tool.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Actions Row */}
        <div className="vtActionsRow">
          <button className="vtActionBtn vtActionTemplate" onClick={() => this.setState({ open: true })}>
            Select Template
          </button>
          <button className="vtActionBtn vtActionShare" onClick={() => this.setState({ forShare: true })}>
            Share & Send
          </button>
          <button className="vtActionBtn vtActionCopy" onClick={this.copyUrl}>
            Copy Link
          </button>
        </div>

        {/* Editor Modals */}
        {this.state.editText && (
          <VideoEditor toggle={() => this.setState({ editText: false })} video={video} type="Text" />
        )}
        {this.state.editLogo && (
          <VideoEditor toggle={() => this.setState({ editLogo: false })} video={video} type="Logo" />
        )}
        {this.state.editMusic && (
          <VideoEditor toggle={() => this.setState({ editMusic: false })} video={video} type="Music" />
        )}
        {this.state.editThumbnail && (
          <VideoEditor toggle={() => this.setState({ editThumbnail: false })} video={video} type="Thumbnail" />
        )}

        <TemplateDialog
          selectedValue={themeName}
          open={open}
          onClose={this.handleCloseTemplate}
        />
        <ShareDialog
          open={forShare}
          onClose={() => this.setState({ forShare: false })}
          receiverEmail={receiverEmail}
          emails={emails}
          emailHandler={this.emailHandler}
          submitEmail={this.submitEmail}
          handleChipAdd={this.handleChipAdd}
          handleDeleteChip={this.handleDeleteChip}
          sendMultipleEmail={this.sendMultipleEmail}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  video: state.video.singleVideo,
});
const mapDispatchToProps = (dispatch: any) => ({
  updateVideo: (video: any) => dispatch(updateVideo(video)),
  sendVideoToEmail: (video: any) => dispatch(sendVideoToEmail(video)),
  sendMultipleEmail: (emailVideoObj: any) => dispatch(sendMultipleEmails(emailVideoObj)),
});
export default withRouter<any, any>(
  connect(mapStateToProps, mapDispatchToProps)(VideoTabHeader)
);
